/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .loading {
    position: absolute;
  }

  .loading:after {
    content: '';
    position: absolute;
    z-index: 100;
    left: 18px;
    top: 4px;
    margin: -0.5em 0 0 -0.5em;
    width: 16px;
    height: 16px;
    font-size: 1.5em;
    border-right: 0.1em solid #bbc0ca;
    border-bottom: 0.1em solid #f0f1f4;
    border-top: 0.1em solid #bbc0ca;
    border-radius: 3em;
    box-sizing: border-box;
    animation: spin 1s infinite linear;
    transition: 1s ease;
  }

  .loading.is-loaded:after {
    opacity: 0;
    visibility: hidden;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  /* Other style */
  body {
    padding: 1%;
    text-align: center;
  }

  a {
    font-family: sans-serif;
    text-decoration: none;
    display: inline-block;
    padding: 0.5em 1em;
    margin: 1em;
    background: #3498db;
    color: #fff;
    border-radius: 3px;
  }

  .box {
    ${(props) =>
      props.spcBag
        ? `right: 13px;
    top: 10;
    bottom: 23px;`
        : 'right: 40px;top: 10;bottom: 21px;'}
  }
`;
